/** Canonical avatar onboarding route — shared by OAuth, email/password, and middleware. */
export function avatarOnboardingPath(next = "/home"): string {
  const safeNext =
    next.startsWith("/") && !next.startsWith("//") ? next : "/home";
  return `/onboarding/avatar?next=${encodeURIComponent(safeNext)}`;
}

export function isAvatarOnboardingPath(pathname: string): boolean {
  return pathname.startsWith("/onboarding/avatar");
}
